<mat-card-content>
  <div class="row align-items-start">

    <div class="col-12 col-sm-12 col-md-3 mb-3">
      <div>
        <h4 style="font-size: 100%;
        font-weight: 700; margin-block-start: 1.33em;
    margin-block-end: 1.33em;">Service Cover Details</h4>
      </div>
      <div style="display: flex; flex-direction: row; gap: 10px;">
        <div>
          @for (detail of premiseFlat.serviceCoverDetails; track detail) {
          <div>
            <span class="property-header">{{detail.displayName}}</span>
          </div>
          }
        </div>
        <div>
          @for (detail of premiseFlat.serviceCoverDetails; track detail) {
          <div>
            <span>{{detail.value}}</span>
          </div>
          }
        </div>
      </div>

      @for (detail of premiseFlat.serviceCoverDetails; track detail) {
      <div style="font-size: 11px; color: grey; font-weight: 500;">
        <div> 
          <span>Created</span>
          <span style="padding-left: 17px;">{{detail.createdDate | date:'dd MMM y HH:mm'}}</span>
        </div>
        <div>
          <span>Modified</span>
          <span style="padding-left: 10px;">{{detail.modifiedDate | date:'dd MMM y HH:mm'}}</span>
        </div>
        @if (detail.deletedDate !== null) {
        <div style="color: red;margin-top: 7px;">
          <span>Deleted</span>
          <span style="padding-left: 17px;">{{detail.deletedDate | date:'dd MMM y HH:mm'}}</span>
        </div>
        }
      </div>
      }
    </div>

    <div class="col-12 col-sm-12 col-md-9 mb-3">

      @if (premiseFlat.storeConfigId || isCreate) {
      <div class="row align-items-start">
        <app-store-flag class="col-12 col-sm-12 col-md-4 mb-3"
                        [header]="'Incoming work orders'"
                        [formGroup]="incomingFormGroup"
                        [ctrlArrayName]="'incomingControlArray'"
                        [flags]="premiseFlat.incoming" [disableStore]="!!premiseFlat.deletedDate"></app-store-flag>

        <app-store-flag class="col-12 col-sm-12 col-md-4 mb-3"
                        [header]="'Outgoing work orders'"
                        [formGroup]="outgoingFormGroup"
                        [ctrlArrayName]="'outgoingControlArray'"
                        [flags]="premiseFlat.outgoing"  [disableStore]="!!premiseFlat.deletedDate"></app-store-flag>

        <app-store-flag class="col-12 col-sm-12 col-md-4 mb-3"
                        [header]="'Held callouts'"
                        [formGroup]="heldCalloutsFormGroup"
                        [ctrlArrayName]="'heldCalloutsControlArray'"
                        [flags]="premiseFlat.callouts"  [disableStore]="!!premiseFlat.deletedDate"></app-store-flag>
      </div>

      <mat-card-actions style="display: flex; align-items: center; flex-wrap: wrap; gap: 10px;">
        <div style="display: flex; gap: 10px;">
          <button mat-flat-button color="primary"
          [disabled]="isFormInvalid"
          (click)="save()">Save
          </button>
          <button mat-stroked-button
                  [disabled]="isFormInvalid"
                  (click)="discard()">Discard
          </button>
        </div>

        <div style="font-size: 11px; color: grey; font-weight: 500; display: flex; flex-direction: column; gap: 4px;">
          <div > 
            <span>Created</span>
            <span style="padding-left: 17px;">{{premiseFlat.createdDate  | date:'dd MMM y HH:mm'}}</span>
          </div>
          <div>
            <span>Modified</span>
            <span style="padding-left: 10px;">{{premiseFlat.modifiedDate | date:'dd MMM y HH:mm'}}</span>
          </div>
          @if (premiseFlat.deletedDate !== null) {
          <div style="color: red;">
            <span>Deleted</span>
            <span style="padding-left: 17px;">{{premiseFlat.deletedDate | date:'dd MMM y HH:mm'}}</span>
          </div>
          }
        </div>

      </mat-card-actions>
      } @else {
      <div style="display: flex; flex-direction: column;">
        <div>
          <h4 style="font-size: 100%; font-weight: 700; margin-block-start: 1.33em; margin-block-end: 1.33em;">No store config found</h4>
        </div>
        @for (detail of premiseFlat.serviceCoverDetails; track detail) {
        <div>
          <button mat-flat-button color="primary" [disabled]="detail.deletedDate" (click)="create()">Create new</button>
        </div>
        }
      </div>
      }
    </div>

  </div>
</mat-card-content>

@if (isLoadingResult) {
<div class="loading-shade">
  @if (isLoadingResult) {
    <mat-spinner></mat-spinner>
  }
</div>
}
